import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Span } from '@sopranodesign/pulse-components';
import { TemplatingTextInput } from '@sopranodesign/pulse-templating';

const SetLocationContent = ({ content, onChange }) => {
  const handleLocationChange = location => {
    onChange({ location });
  };

  return (
    <Flex center fat="true" xSpace>
      <Span>using</Span>
      <Flex col fat>
        <TemplatingTextInput
          aria-label="Location"
          placeholder="England"
          value={content.location}
          onChange={handleLocationChange}
        />
      </Flex>
    </Flex>
  );
};

SetLocationContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.shape({
    location: PropTypes.string.isRequired
  }).isRequired
};

export default SetLocationContent;
